<template>
  <div style="width:100%">
    <headtop :headid="headid"></headtop>
    <div class="story_home">
      <!-- 搜索 -->
      <div class="search_box">
          <div class="search">
          <img src="@/assets/img/mianhui/search.png" alt="">
          <input class="search_inp" placeholder="请输入模糊关键字" v-model="title" type="text">
          <button class="search_btn" @click="getsearch">搜索</button>
          </div>
      </div>
    <!-- 主体内容 -->
    <div class="story-box">
      <div class="story-banner">
        <el-carousel :interval="4000" type="card" height="500px" indicator-position="outside">
          <el-carousel-item v-for="(item,index) in imgBannerList" :key="index"  :class="'banner-item'+index">
            <img :src="item.images" alt="" @click="gotoDetails(item)"/>
            <div class="banner-title">
              <p class="item-title">{{ item.title }}</p>
              <!-- <p class="item-text">{{ item.p2 }}</p> -->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    </div>
    <!-- 用于切换图文模块的组件 -->
    <div class="story-wrapper">
        <image-component :imgPageData="imgPageData"></image-component>
        <text-component v-show="textVisble"></text-component>
    </div>
    <!-- 分页 -->
    <el-pagination
      background
      style="margin: 68px 0 83px 0; text-align: center;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNo"
      :page-size="pageSize"
      :layout="layout"
      :total="totalCount">
    </el-pagination>
  </div>
</template>
<script>

import headtop from "@/components/Headtop.vue"
import imageComponent from "@/components/imgAndText/imageComponent.vue" // 图文组件
import textComponent from "@/components/imgAndText/textComponent.vue" // 标题组件

export default {
  name: 'Touchingstory',
  components:{
    headtop,
    imageComponent,
    textComponent
  },
  props: {
   
  },
  data() {
    return{
      title: '',
      textVisble: false, // 纯文组件
      imgPageData: [], // 图文数据
      imgBannerList: [], // 轮播数据
      pageNo: 1, // 当前页
      pageSize: 8, // 每页显示多少
      totalCount: 0, // 总条数
      layout: 'prev, pager, next, jumper', // 分页类型
      menuId: '', // 头部获取ID
      headid:''
    }
  },
  created() {
  },
  mounted() {
    this.menuId = this.$route.query.id
    this.headid = this.$route.query.id
    this.getImgText()
  },
  methods: {
    // 跳转
    gotoDetails(item) {
        this.$router.push({
          path: '/storyDetails',
          query: {
              id: item.id,
              date: item.release_date
          }
        })
      },
      // 获取数据
    async getImgText() {
      let res = await this.api.query('list_website_title_text', {
        fk_menu_id: this.menuId,
        title: this.title,
        page: this.pageNo,
        rows: this.pageSize,
      })
      if (res.status == 200) {
        this.imgPageData = res.data.data
        this.totalCount = res.data.datax
        this.imgBannerList = res.data.data.slice(0,3)
      } else {
        this.$message.error(res.data.message);
      }
    },
    // 分页操作
    handleCurrentChange(val) {
      this.pageNo = val
      this.getImgText()
    },
    handleSizeChange(side) { 
      this.pageNo = 1
      this.pageSize = side
      this.getImgText()
    },
    getsearch(){
      this.pageNo = 1
      this.getImgText()
    },
   
  }
}
</script>
<style lang="scss" scoped>
.story_home{
  width: 100%;
  height: 570px;
  background-image: url('~@/assets/img/story/story5.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  // margin: 0 auto;
}
.search_box{
  width: 100%;
  height: 50px;
  .search {
    width: 386px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    border: 1px solid #0A362A;
    line-height: 40px;
    position: absolute;
    top: 105px;
    right: 357px;
    ::placeholder {
      text-indent: 51px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #616161;
    }
    img {
      position: absolute;
      margin-top: 15px;
      left: 24px;
    }
    .search_inp{
      width: 240px;
      height: 28px;
      border: none;
      border: 0;
      margin-left: 50px;
    }
    .search_btn{
      position: absolute;
      right: 0;
      bottom: 0;
      width: 74px;
      height: 40px;
      background: #0A362A;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
.story-box {
  width: 100%;
  height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
    .story-banner {
      width: 56%;
    .banner-item0 {
      width: 519px;
      height: 399px;
      background: RGBA(167, 86, 121, 1);
      border-radius: 0px 0px 0px 0px;
      img {
        width: 519px;
        height: 262px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
      .banner-title {
        align-items: center;
        margin-left: 36px;
        .item-title{
          height: 28px;
          font-size: 20px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 18px;
          margin-top: 15px;
        }
        .item-text {
          // width: 320px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .banner-item1{
      background: #517871;
      width: 519px;
      height: 399px;
      border-radius: 0px 0px 0px 0px;
      opacity: 30;
      img {
        width: 519px;
        height: 262px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
      .banner-title {
        align-items: center;
        margin-left: 36px;
        .item-title{
          height: 28px;
          font-size: 20px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 18px;
          margin-top: 15px;
        }
        .item-text {
          // width: 320px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .banner-item2{
      background: #C5906E;
      width: 519px;
      height: 399px;
      border-radius: 0px 0px 0px 0px;
      opacity: 30;
      img {
        width: 519px;
        height: 262px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
      .banner-title {
        align-items: center;
        margin-left: 36px;
        .item-title{
          height: 28px;
          font-size: 20px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 18px;
          margin-top: 15px;
        }
        .item-text {
          // width: 320px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
}
}

.story-wrapper {
  width: 70%;
  // border:1px solid red;
  // margin-left: 358px;
  // margin-right: 358px;
  margin-left: 16%;
  margin-right: 15%;
}
</style>